:host {
  display: block;
  margin-top: 6px;

  --default-border-size: 1px;
  --min-textarea-height: 128px;
  --min-textarea-width: 272px;
  --textarea-padding-h: 16px;
  --textarea-padding-v: 14px;
}

.dc-textarea {
  background-color: var(--dc-background-colour);
  display: block;
  position: relative;
  
}

.dc-textarea-label {
  background-color: var(--dc-background-colour);
  color: var(--dc-primary-text-color);
  display: block;
  font-family: var(--dc-font-family);
  font-weight: 400;
  font-size: 16px;
  margin-left: 12px;
  padding: 0 4px;
  position: absolute;
  top: 14px;
  transition: all 0.3s;
}

.dc-textarea-wrap {
  display: flex;
  flex-direction: column;
}

.dc-textarea-input {
  background-color: var(--dc-background-colour);
  border: var(--default-border-size) solid var(--dc-ui-border-default);
  border-radius: 8px;
  box-shadow: none;
  box-sizing: border-box;
  caret-color: var(--dc-primary-colour);
  color: var(--dc-primary-text-color);
  font-family: var(--dc-font-family);
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.16px;
  line-height: 24px;
  outline: 0;
  padding: var(--textarea-padding-v) var(--textarea-padding-h);
  height: var(--min-textarea-height);
  width: var(--min-textarea-width);
}

.dc-textarea-input::placeholder {
  color: var(--dc-accent-text-color);
}

.dc-textarea-help {
  color: var(--dc-accent-text-color);
  font-family: var(--dc-font-family);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-left: 16px;
  margin-top: 4px;
  word-wrap: break-word;
}

/* View control */
.dc-textarea-view .dc-textarea-input::placeholder {
  color: transparent;
}

/* Edit control */
.dc-textarea-edit .dc-textarea-label {
  font-size: 12px;
  top: -6px;
}

/* Character counter */
.dc-textarea-counter {
  background-color: var(--dc-background-colour);
  color: var(--dc-primary-text-color);
  display: none;
  font-family: var(--dc-font-family);
  font-size: 12px;
  padding: 0 4px;
  position: absolute;
  right: 12px;
  top: -6px;
}

.dc-textarea-edit .dc-textarea-counter {
  display: block;
}

/* Hover State */
.dc-textarea-input:hover:enabled {
  border-color: var(--dc-primary-accent-colour);
}

/* Focus State */
.dc-textarea-edit .dc-textarea-input:focus {
  border: 2px solid var(--dc-primary-colour);
  padding: calc(var(--textarea-padding-v) - 1px) calc(var(--textarea-padding-h) - 1px);
}

/* Disabled State */
.dc-textarea-disabled .dc-textarea-label {
  border-color: var(--dc-ui-disabled-border);
  color: var(--dc-greyscale-04);
}

.dc-textarea-disabled .dc-textarea-help {
  color: var(--dc-greyscale-04);
}

.dc-textarea-disabled .dc-textarea-input,
.dc-textarea-disabled .dc-textarea-counter {
  color: var(--dc-greyscale-04);
  border-color: var(--dc-ui-disabled-border);
  cursor: not-allowed;
}


/* Error state */
.dc-textarea-error-icon {
  display: none;
}

.dc-textarea-error .dc-textarea-error-icon {
  display: block;
  position: absolute;
  left: calc(100% - 24px);
  top: 16px;
}

.dc-textarea-error-icon path {
fill: var( --dc-primary-error-color);
}

.dc-textarea-error-msg {
  display: none;
  color: var( --dc-primary-error-color);
  font-family: var(--dc-font-family);
  font-weight: 400;
  font-size: 12px;
  margin: 0;
  padding: 4px 0 0 16px;
  max-width: 270px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.dc-textarea-error .dc-textarea-error-msg {
  display: block;
}

.dc-textarea-error .dc-textarea-input::after {
  content: url("data:image/svg+xml,%20%20%20%20%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10%2013.5C10%2012.125%208.875%2011%207.5%2011C6.09375%2011%205%2012.125%205%2013.5C5%2014.9062%206.09375%2016%207.5%2016C8.875%2016%2010%2014.9062%2010%2013.5ZM5.28125%200.8125L5.6875%209.3125C5.71875%209.6875%206.0625%2010%206.4375%2010H8.53125C8.90625%2010%209.25%209.6875%209.28125%209.3125L9.6875%200.8125C9.71875%200.375%209.375%200%208.9375%200H6.03125C5.59375%200%205.25%200.375%205.28125%200.8125Z%22%20fill%3D%22%23CF364E%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E");
  height: 16px;
  width: 16px;
}

.dc-textarea-error .dc-textarea-input,
.dc-textarea-error .dc-textarea-input:focus {
  border: 2px solid var(--dc-primary-error-color);
  padding: calc(var(--textarea-padding-v) - 1px) calc(var(--textarea-padding-h) - 1px);
}
